<template>
    <div class="compo-form-item">
        <div class="compo-form-name">
            <label class="compo-form-title">결제정보</label>
        </div>
        <div class="compo-form-body">
            <PaymentSummaryData
                :productItem="productItem"
            ></PaymentSummaryData>
        </div>
        <!-- <div class="compo-info-box">
            - <br>
            - <br>
            - 
        </div> -->
    </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    components: {
        PaymentSummaryData: () => import('@/components/order-item/PaymentSummaryData.vue'), // 결제 정보 테이블
    },
    props:{
        productItem : {
            type: Object,
            required: true
        },
    },

    data() {
        return {            
        }
    },

    computed: {
		...mapState({
            userData: state => state.userData,
            userNo: state => state.userNo,
            orderCnt: state => state.orderCnt,
            goodsPricePoc: state => state.goodsPricePoc,
            goodsPriceMarket: state => state.goodsPriceMarket,
        }),
	},

}
</script>

<style lang="scss" scoped>
@import '@/assets/css/order.scss';

</style>